module.exports = __webpack_public_path__ + "assets/94948a671d5fc8bb271ade41ad6e6935.png";